import Img6 from "../assets/images/gregory.png";
import Img7 from "../assets/images/oamen.png";
import Img8 from "../assets/images/yehu.png";
import Img11 from "../assets/images/ephraim.png";
import Img9 from "../assets/images/charity.png";
import Img10 from "../assets/images/tamu.png";
import Img03 from "../assets/images/eziaku.png";
import Img04 from "../assets/images/felix.png";
import Img05 from "../assets/images/chinyere.png";
import Img06 from "../assets/images/akpan.png";
import Img07 from "../assets/images/nwankwo.png";
import Img08 from "../assets/images/alalibo.png";
import Img09 from "../assets/images/godwin.png";
import Img001 from "../assets/images/leonard.png";
import Img002 from "../assets/images/joseph.png";
import Img003 from "../assets/images/micheal.png";
import Img01 from "../assets/images/chukwuemeka.png";
import Img004 from "../assets/images/sylvester.png";
import Img005 from "../assets/images/hilary.png";
import Img006 from "../assets/images/adekunle.png";
import Img007 from "../assets/images/balogun.png";
import Img008 from "../assets/images/sunny.png";
import Img009 from "../assets/images/okorie.png";
import Img0001 from "../assets/images/dagogo.png";
import Img0002 from "../assets/images/okay.png";
import Img0003 from "../assets/images/benjamin.png";
import Img0004 from "../assets/images/melvin.png";
import HOD from "../assets/images/hod.png";
export const lecturers = [
  {
    name: "Professor Felix Ugbana Nte ",
    img: HOD,
    position: "H.O.D",
    info: " BSc.in Physics and Material Science as first batch, Post Graduate Diploma in Education 1985, M. Phil/Ph.D. in Environmental Physic,",
    fbHandle: "",
    twitterHandle: "",
    linkedinHandle: "",
    emailHandle: "",
    id: 1,
  },
  {
    name: "Prof.Charity Ukpok-Awaji Okujagu",
    img: Img9,
    position: "Professor",
    info: "M.Sc. degree in meteorology, Ph.D. degree in Solar Energy",
    fbHandle: "",
    twitterHandle: "",
    linkedinHandle: "",
    emailHandle: "",
    id: 1,
  },
  {
    name: " Prof. Oamen E. Abumere",
    img: Img7,
    position: "Professor",
    info: "B.Sc. From (OAU, 1978), PhD in Solid State Physics ",
    fbHandle: "",
    twitterHandle: "",
    linkedinHandle: "",
    emailHandle: "",
    id: 1,
  },
  {
    name: "Prof. Tamunouni M. Abbey",
    img: Img10,
    position: "Professor",
    info: "Applied Mathematics and Theoretical Physics (plasma Astrophysics)",
    fbHandle: "",
    twitterHandle: "",
    linkedinHandle: "",
    emailHandle: "",
    id: 1,
  },
];
export const academicStaff = [
  {
    name: "Prof Gregory O. Avwiry",
    img: Img6,
    position: "Professor",
    info: "B. Sc.in Physics /Electronics (1988) and M.Sc. ",
    fbHandle: "",
    twitterHandle: "",
    linkedinHandle: "",
    emailHandle: "",
    id: 1,
  },
  {
    name: " Prof. Oamen E. Abumere",
    img: Img7,
    position: "Professor",
    info: "B.Sc. From (OAU, 1978), PhD in Solid State Physics ",
    fbHandle: "",
    twitterHandle: "",
    linkedinHandle: "",
    emailHandle: "",
    id: 1,
  },
  {
    name: "Prof. Tamunouni M. Abbey",
    img: Img10,
    position: "Professor",
    info: "Applied Mathematics and Theoretical Physics (plasma Astrophysics)",
    fbHandle: "",
    twitterHandle: "",
    linkedinHandle: "",
    emailHandle: "",
    id: 1,
  },
  {
    name: "Prof.Charity Ukpok-Awaji Okujagu",
    img: Img9,
    position: "Professor",
    info: "M.Sc. degree in meteorology, Ph.D. degree in Solar Energy",
    fbHandle: "",
    twitterHandle: "",
    linkedinHandle: "",
    emailHandle: "",
    id: 1,
  },
  {
    name: "Prof. Ephraim O. Chukwuocha",
    img: Img11,
    position: "Professor",
    info: "B.Sc. Physics/Electronics, M.Sc. in Physics (Solid State), PhD in Theoretical Physics",
    fbHandle: "",
    twitterHandle: "",
    linkedinHandle: "",
    emailHandle: "",
    id: 1,
  },
  {
    name: "Prof. Chukwuemeka N. Ehirim",
    img: Img01,
    position: "Professor",
    info: "BSc. (Hons) degree in Physics, M.Sc. and PhD degrees in Applied Geophysics",
    fbHandle: "",
    twitterHandle: "",
    linkedinHandle: "",
    emailHandle: "",
    id: 1,
  },
  {
    name: "Prof. Yehuwdah E. Chad-Umoren",
    img: Img8,
    position: "Professor",
    info: "B.Sc. Physics (Nuclear Physics option),  M. Sc. Physics (Nuclear Physics), Ph. D. Nuclear and Radiation Physics from ",
    fbHandle: "",
    twitterHandle: "",
    linkedinHandle: "",
    emailHandle: "",
    id: 1,
  },
  {
    name: "Prof. Eziaku Osarolube ",
    img: Img03,
    position: "Professor",
    info: "B.Sc. Tech degree in Industrial Physics, M.Sc. degree in Solid State Physics, Ph.D. degree in material Science",
    fbHandle: "",
    twitterHandle: "",
    linkedinHandle: "",
    emailHandle: "",
    id: 1,
  },
  {
    name: "Prof. Felix Ugbana Nte ",
    img: Img04,
    position: "Professor",
    info: "B.Sc. UPH, PGDE ABU, M.Phil./Ph.D",
    fbHandle: "",
    twitterHandle: "",
    linkedinHandle: "",
    emailHandle: "",
    id: 1,
  },
  {
    name: "Prof.  Chinyere P. Ononugbo ",
    img: Img05,
    position: "Professor",
    info: "M.Sc. (2002- Radiation and Environmental protection), Ph.D. (2012- Environmental Physics) ",
    fbHandle: "",
    twitterHandle: "",
    linkedinHandle: "",
    emailHandle: "",
    id: 1,
  },
  {
    name: "Prof.  Akpan Ndem Ikot ",
    img: Img06,
    position: "Professor",
    info: "PhD degree in theoretical Physics ",
    fbHandle: "",
    twitterHandle: "",
    linkedinHandle: "",
    emailHandle: "",
    id: 1,
  },
  {
    name: "Prof. C.N. Nwankwo ",
    img: Img07,
    position: "Professor",
    info: " PhD in Applied Geophysics ",
    fbHandle: "",
    twitterHandle: "",
    linkedinHandle: "",
    emailHandle: "",
    id: 1,
  },
  {
    name: "Prof.  Alalibo T. Ngiangia",
    img: Img08,
    position: "Professor",
    info: " B.Sc. (1998) in Pure and Applied Mathematics, M.Sc. (2004) and Ph.D. (2012) in Theoretical Physics ",
    fbHandle: "",
    twitterHandle: "",
    linkedinHandle: "",
    emailHandle: "",
    id: 1,
  },
];
export const nonAcademicStaff = [
  {
    name: "Dr. Godwin O. Emujakporue",
    img: Img09,
    position: "Doctor",
    info: "  ",
    fbHandle: "",
    twitterHandle: "",
    linkedinHandle: "",
    emailHandle: "",
    id: 1,
  },
  {
    name: "Dr. Leonard I.  Nwosu ",
    img: Img001,
    position: "Doctor",
    info: "B.Sc. Hons. in Physics (1990); M.Sc in Applied Geophysics (1998) and  Ph.D in Applied Geophysics (2013)  ",
    fbHandle: "",
    twitterHandle: "",
    linkedinHandle: "",
    emailHandle: "",
    id: 1,
  },
  {
    name: "Dr. Joseph A. Amusan ",
    img: Img002,
    position: "Doctor",
    info: "(B.Tech.) in Pure and Applied Physics, Master of Technology (M.Tech.) in Applied Physics (Renewable energy, Electronics and communication option), (Ph.D.) in Applied Physics (Instrumentation and Nanotechnology)  ",
    fbHandle: "",
    twitterHandle: "",
    linkedinHandle: "",
    emailHandle: "",
    id: 1,
  },
  {
    name: "Dr. Michael C. Onyeaju",
    img: Img003,
    position: "Doctor",
    info: " PhD degree in Theoretical/Mathematical Physic",
    fbHandle: "",
    twitterHandle: "",
    linkedinHandle: "",
    emailHandle: "",
    id: 1,
  },
  {
    name: " Dr. Sylvester E. Onwuneme",
    img: Img004,
    position: "Doctor",
    info: "B.Sc. Hons. in Physics (2001); M.Sc. in Atmospheric Physics (2005) and Ph.D. in Theoretical Physics (2016)",
    fbHandle: "",
    twitterHandle: "",
    linkedinHandle: "",
    emailHandle: "",
    id: 1,
  },
  {
    name: "Dr. Hilary P. Obong",
    img: Img005,
    position: "Doctor",
    info: "B.Sc. (1987) from the University Calabar, M.Sc. (1993) and PhD. (2017)",
    fbHandle: "",
    twitterHandle: "",
    linkedinHandle: "",
    emailHandle: "",
    id: 1,
  },
  {
    name: "Dr. Adekunle O. Sofolabo",
    img: Img006,
    position: "Doctor",
    info: "Member: SEG, NAPE, AAPG, NIP AND SPE and presently the Rivers state chapter coordinator of NIP",
    fbHandle: "",
    twitterHandle: "",
    linkedinHandle: "",
    emailHandle: "",
    id: 1,
  },
  {
    name: "Dr. Balogun O. Ayomide ",
    img: Img007,
    position: "Doctor",
    info: "B.Sc. (Hons) Physics, 2005. In 2009, he obtained MSc in Applied Geophysics and PhD in 2018 (Applied Geophysics)",
    fbHandle: "",
    twitterHandle: "",
    linkedinHandle: "",
    emailHandle: "",
    id: 1,
  },
  {
    name: "Dr. Sonny Inichinbia ",
    img: Img008,
    position: "Doctor",
    info: "B.Sc. (Hons.) in Physics/Materials Science, (M.Sc., 2008) and (Ph.D., 2014) in Applied Geophysics ",
    fbHandle: "",
    twitterHandle: "",
    linkedinHandle: "",
    emailHandle: "",
    id: 1,
  },
  {
    name: "Dr. Okay. F. Adizua",
    img: Img0002,
    position: "Doctor",
    info: "B.Sc. (Honors) and M.Sc. Degrees in Applied Geophysics, Ph.D in the same field from a Geological Sciences Background  ",
    fbHandle: "",
    twitterHandle: "",
    linkedinHandle: "",
    emailHandle: "",
    id: 1,
  },
  {
    name: "Dr. Dagogo Tamuno",
    img: Img0001,
    position: "Doctor",
    info: "BSc. (Hons), Physics (Applied Geophysics) 2005,  MSc. in Applied Geophysics (2011)",
    fbHandle: "",
    twitterHandle: "",
    linkedinHandle: "",
    emailHandle: "",
    id: 1,
  },
];
export const others = [
  {
    name: "Mr. I. P. C. Okorie",
    img: Img009,
    position: "Lecturer",
    info: "(B.Tech. in Geology/Geophysics)  ",
    fbHandle: "",
    twitterHandle: "",
    linkedinHandle: "",
    emailHandle: "",
    id: 1,
  },

  {
    name: " Mr. Benjamin E. Otokunefor",
    img: Img0003,
    position: "Lecturer",
    info: "B.SC. in Physics (Electronic Option) as well as M.Sc. Solid State Electronics",
    fbHandle: "",
    twitterHandle: "",
    linkedinHandle: "",
    emailHandle: "",
    id: 1,
  },
  {
    name: " Mr. Melvin J. Idonije",
    img: Img0004,
    position: "Lecturer",
    info: "B.Sc. in Industrial Physics, B.Sc. in Industrial Physics",
    fbHandle: "",
    twitterHandle: "",
    linkedinHandle: "",
    emailHandle: "",
    id: 1,
  },
];
export const staffList = [
  {
    id: 1,
    num: 1,
    name: "Dukobo, T.G.",
    qualification: "HND, (NIST) FIN. DIP, (NIST), INTELNP. NIST, WAEC, FSLC",
    role: "Chief Technologist",
    specialization: "Physics/Electronics",
  },

  {
    id: 2,
    num: 2,
    name: "Elenwo, P.O.",
    qualification: "SSCE, ND (NIST), HND, B.Tech, M.Sc., PhD.",
    role: "Chief Technologist",
    specialization: "Instrumentation/Material Science.",
  },
  {
    id: 3,
    num: 3,
    name: "Akenzua, O.S.",
    qualification: "B.Eng in view, ND, ND, WAEC",
    role: "Chief Technologist",
    specialization: "Physics Electronics",
  },
  {
    id: 4,
    num: 4,
    name: "Lawal M.",
    qualification: "B.TECH., HND, OND & SSCE",
    role: "Principal Tech.",
    specialization: "Physics-Electronics",
  },
  {
    id: 5,
    num: 5,
    name: "Nwchukwu, C.U.",
    qualification: "SSCE, BTC (NIST) ND",
    role: "Principal Tech.",
    specialization: "Physics-Electronics",
  },
  {
    id: 6,
    num: 6,
    name: "Ogbonna, B.O.",
    qualification: "WAEC, B.TECH. M.ENG (MNSE)",
    role: "Senior Tech.",
    specialization: "Electrical systems and Machines",
  },
  {
    id: 7,
    num: 7,
    name: "Deeyor, Baridi",
    qualification: "SSCE, B.Tech",
    role: "Technologist I",
    specialization: "Physics-Electronics",
  },
  {
    id: 8,
    num: 8,
    name: "Egbo, C. Collins",
    qualification: "SSCE, OND, (NIST), HND (NIST), BSc",
    role: "Technologist I",
    specialization: "Geophysics",
  },
  {
    id: 9,
    num: 9,
    name: "Herbert-Paul, Joy C.",
    qualification: "SSCE, OND HND (NIST)",
    role: "Technologist I",
    specialization: "Physics/Electronics",
  },
  {
    id: 10,
    num: 10,
    name: "Ekeh, E. Chijioke",
    qualification: "SSCE, BTECH (Phy/Electronics)",
    role: "Technologist I",
    specialization: "Physics/Electronics",
  },
  {
    id: 11,
    num: 11,
    name: "Odike, Odike C.",
    qualification: "SSCE, NREP, HSC level (1,2,3), B.TECH",
    role: "Technologist I",
    specialization: "Physics/Production",
  },
  {
    id: 12,
    num: 12,
    name: "Woha, B.N.",
    qualification: "WAEC",
    role: "Lab. Supervisor",
    specialization: "Physics-/Advanced Lab",
  },
  {
    id: 13,
    num: 13,
    name: "Nwabueze, J.B.",
    qualification: "WAEC",
    role: "Lab. Assistant",
    specialization: "",
  },
];
export const nonAcademicstaffList = [
  {
    id: 1,
    num: 1,
    name: "Amadi M.N.",
    qualification: "B.Sc.",
    role: "Senior Executive officer",
  },

  {
    id: 2,
    num: 2,
    name: "Olluor, Ijeoma Chigonum",
    qualification: " B.Sc.",
    role: "Administrative Officer",
  },
  {
    id: 3,
    num: 3,
    name: "Ozowhuor Frederick",
    qualification: "B.A.",
    role: "Senior Executive Officer",
  },
  {
    id: 4,
    num: 4,
    name: "Opara, Esther ",
    qualification: "SSCE",
    role: "Computer Operator",
  },
  {
    id: 5,
    num: 5,
    name: "Anokam, Gladys-Benaiah O.",
    qualification: "OND",
    role: "Personal Secretary III",
  },
  {
    id: 6,
    num: 6,
    name: "Ogbaka, Violet",
    qualification: "FSLC",
    role: "Cleaner/Messenger",
  },
  {
    id: 7,
    num: 7,
    name: "Okenwor, Gladys",
    qualification: "FSLC",
    role: "Caretaker",
  },
];
